module.exports = __webpack_public_path__ + "static/media/FFG.60d5c592.mp4";